import { Link } from "react-router-dom";

export default function VideoInfo() {
  return (
    <section className="w-full px-4 md:px-8 lg:px-12 py-8 md:py-12">
      <div className="bg-white rounded-2xl md:rounded-3xl overflow-hidden">
        <div className="flex flex-col lg:flex-row">
          {/* Event info */}
          <div className="lg:w-1/2 p-6 md:p-8 lg:p-10 flex flex-col justify-center">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-primary-500 flex items-center justify-center overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/c966e299d7275505654852a65f959d1a.png"
                  alt="Logo Baños Run"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <p className="text-xs text-primary-500 font-semibold tracking-widest uppercase">BAÑOS, ECUADOR - 2026</p>
                <p className="text-xs text-foreground-400">ATEC - World Athletics</p>
              </div>
            </div>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 tracking-wide mb-2">
              BAÑOS RUN
            </h2>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-primary-500 tracking-wide mb-4">
              2026
            </h2>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              El <strong>Campeonato Nacional de Carreras de Calle 2026</strong> llega a Baños de Agua Santa.
              Un evento de calidad internacional certificado por World Athletics con circuito urbano
              por las principales calles de la ciudad.
            </p>

            <div className="grid grid-cols-2 gap-3 mb-6">
              <div className="bg-background-50 rounded-xl p-3 text-center">
                <p className="font-heading text-2xl text-primary-500">21K</p>
                <p className="text-xs text-foreground-500">Media Maratón</p>
              </div>
              <div className="bg-background-50 rounded-xl p-3 text-center">
                <p className="font-heading text-2xl text-primary-500">5K</p>
                <p className="text-xs text-foreground-500">Carrera</p>
              </div>
              <div className="bg-background-50 rounded-xl p-3 text-center">
                <p className="font-heading text-2xl text-primary-500">Milla</p>
                <p className="text-xs text-foreground-500">Clásica</p>
              </div>
              <div className="bg-background-50 rounded-xl p-3 text-center">
                <p className="font-heading text-2xl text-accent-500">$20</p>
                <p className="text-xs text-foreground-500">Inscripción</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/inscribirse"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                INSCRIBIRSE AHORA
              </Link>
              <Link
                to="/reglamento"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 font-semibold hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                VER REGLAMENTO
              </Link>
            </div>
          </div>

          {/* Medal image */}
          <div className="lg:w-1/2 p-4 md:p-6 flex items-center justify-center bg-background-50">
            <img
              src="https://static.readdy.ai/image/3ac88beca320db2f961147cc19b75475/e89f44aa2a02ceea3caa33f1d9d60e7c.png"
              alt="Medalla Baños Run 2026 - 21K 5K Milla"
              className="w-full max-w-md h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}